/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { HrTimesheet } from '../model/hrTimesheet';
import { HrTimesheetWeek } from '../model/hrTimesheetWeek';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class HrTimesheetService {

    protected basePath = 'https://gateway.dev.meu-solutions.com/staginganawork';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param year 
     * @param noWeek 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiHrMyTimesheetsYearNoWeekGet(year: number, noWeek: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiHrMyTimesheetsYearNoWeekGet(year: number, noWeek: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiHrMyTimesheetsYearNoWeekGet(year: number, noWeek: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiHrMyTimesheetsYearNoWeekGet(year: number, noWeek: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (year === null || year === undefined) {
            throw new Error('Required parameter year was null or undefined when calling apiHrMyTimesheetsYearNoWeekGet.');
        }

        if (noWeek === null || noWeek === undefined) {
            throw new Error('Required parameter noWeek was null or undefined when calling apiHrMyTimesheetsYearNoWeekGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/hrMyTimesheets/${encodeURIComponent(String(year))}/${encodeURIComponent(String(noWeek))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param year 
     * @param noWeek 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiHrMyTimesheetsYearNoWeekPost(year: number, noWeek: number, body?: Array<HrTimesheet>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiHrMyTimesheetsYearNoWeekPost(year: number, noWeek: number, body?: Array<HrTimesheet>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiHrMyTimesheetsYearNoWeekPost(year: number, noWeek: number, body?: Array<HrTimesheet>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiHrMyTimesheetsYearNoWeekPost(year: number, noWeek: number, body?: Array<HrTimesheet>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (year === null || year === undefined) {
            throw new Error('Required parameter year was null or undefined when calling apiHrMyTimesheetsYearNoWeekPost.');
        }

        if (noWeek === null || noWeek === undefined) {
            throw new Error('Required parameter noWeek was null or undefined when calling apiHrMyTimesheetsYearNoWeekPost.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/hrMyTimesheets/${encodeURIComponent(String(year))}/${encodeURIComponent(String(noWeek))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param tsWeekId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiHrTimesheetWeeksTsWeekIdApprovePut(tsWeekId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiHrTimesheetWeeksTsWeekIdApprovePut(tsWeekId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiHrTimesheetWeeksTsWeekIdApprovePut(tsWeekId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiHrTimesheetWeeksTsWeekIdApprovePut(tsWeekId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tsWeekId === null || tsWeekId === undefined) {
            throw new Error('Required parameter tsWeekId was null or undefined when calling apiHrTimesheetWeeksTsWeekIdApprovePut.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('put',`${this.basePath}/api/hrTimesheetWeeks/${encodeURIComponent(String(tsWeekId))}/approve`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param tsWeekId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiHrTimesheetWeeksTsWeekIdPut(tsWeekId: string, body?: HrTimesheetWeek, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiHrTimesheetWeeksTsWeekIdPut(tsWeekId: string, body?: HrTimesheetWeek, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiHrTimesheetWeeksTsWeekIdPut(tsWeekId: string, body?: HrTimesheetWeek, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiHrTimesheetWeeksTsWeekIdPut(tsWeekId: string, body?: HrTimesheetWeek, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tsWeekId === null || tsWeekId === undefined) {
            throw new Error('Required parameter tsWeekId was null or undefined when calling apiHrTimesheetWeeksTsWeekIdPut.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/hrTimesheetWeeks/${encodeURIComponent(String(tsWeekId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param tsWeekId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiHrTimesheetWeeksTsWeekIdRejectPut(tsWeekId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiHrTimesheetWeeksTsWeekIdRejectPut(tsWeekId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiHrTimesheetWeeksTsWeekIdRejectPut(tsWeekId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiHrTimesheetWeeksTsWeekIdRejectPut(tsWeekId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tsWeekId === null || tsWeekId === undefined) {
            throw new Error('Required parameter tsWeekId was null or undefined when calling apiHrTimesheetWeeksTsWeekIdRejectPut.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('put',`${this.basePath}/api/hrTimesheetWeeks/${encodeURIComponent(String(tsWeekId))}/reject`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param tsWeekId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiHrTimesheetWeeksTsWeekIdSubmitPut(tsWeekId: string, body?: HrTimesheetWeek, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiHrTimesheetWeeksTsWeekIdSubmitPut(tsWeekId: string, body?: HrTimesheetWeek, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiHrTimesheetWeeksTsWeekIdSubmitPut(tsWeekId: string, body?: HrTimesheetWeek, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiHrTimesheetWeeksTsWeekIdSubmitPut(tsWeekId: string, body?: HrTimesheetWeek, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tsWeekId === null || tsWeekId === undefined) {
            throw new Error('Required parameter tsWeekId was null or undefined when calling apiHrTimesheetWeeksTsWeekIdSubmitPut.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/hrTimesheetWeeks/${encodeURIComponent(String(tsWeekId))}/submit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param year 
     * @param noWeek 
     * @param Filters 
     * @param Sorts 
     * @param Page 
     * @param PageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiHrTimesheetsMyApprovalRequestYearNoWeekGet(year: number, noWeek: number, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiHrTimesheetsMyApprovalRequestYearNoWeekGet(year: number, noWeek: number, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiHrTimesheetsMyApprovalRequestYearNoWeekGet(year: number, noWeek: number, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiHrTimesheetsMyApprovalRequestYearNoWeekGet(year: number, noWeek: number, Filters?: string, Sorts?: string, Page?: number, PageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (year === null || year === undefined) {
            throw new Error('Required parameter year was null or undefined when calling apiHrTimesheetsMyApprovalRequestYearNoWeekGet.');
        }

        if (noWeek === null || noWeek === undefined) {
            throw new Error('Required parameter noWeek was null or undefined when calling apiHrTimesheetsMyApprovalRequestYearNoWeekGet.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Filters !== undefined && Filters !== null) {
            queryParameters = queryParameters.set('Filters', <any>Filters);
        }
        if (Sorts !== undefined && Sorts !== null) {
            queryParameters = queryParameters.set('Sorts', <any>Sorts);
        }
        if (Page !== undefined && Page !== null) {
            queryParameters = queryParameters.set('Page', <any>Page);
        }
        if (PageSize !== undefined && PageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>PageSize);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/hrTimesheets/myApprovalRequest/${encodeURIComponent(String(year))}/${encodeURIComponent(String(noWeek))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param staffId 
     * @param year 
     * @param noWeek 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiHrTimesheetsStaffIdYearNoWeekGet(staffId: string, year: number, noWeek: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiHrTimesheetsStaffIdYearNoWeekGet(staffId: string, year: number, noWeek: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiHrTimesheetsStaffIdYearNoWeekGet(staffId: string, year: number, noWeek: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiHrTimesheetsStaffIdYearNoWeekGet(staffId: string, year: number, noWeek: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (staffId === null || staffId === undefined) {
            throw new Error('Required parameter staffId was null or undefined when calling apiHrTimesheetsStaffIdYearNoWeekGet.');
        }

        if (year === null || year === undefined) {
            throw new Error('Required parameter year was null or undefined when calling apiHrTimesheetsStaffIdYearNoWeekGet.');
        }

        if (noWeek === null || noWeek === undefined) {
            throw new Error('Required parameter noWeek was null or undefined when calling apiHrTimesheetsStaffIdYearNoWeekGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/hrTimesheets/${encodeURIComponent(String(staffId))}/${encodeURIComponent(String(year))}/${encodeURIComponent(String(noWeek))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
